import "@babel/polyfill";
import "normalize.css";
import "./plugins/";

import Vue from "vue";
import VueGtm from "vue-gtm";

import App from "./App.vue";
import router from "./router";
import store from "./store/";
import vuetify from "./plugins/vuetify";
import "./plugins/v-mask";

if (process.env.NODE_ENV === "production") {
  Vue.use(VueGtm as any, {
    id: "GTM-NTHTNVM",
    debug: false,
    loadScript: true,
    vueRouter: router,
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
